import { render, staticRenderFns } from "./ModalShipmentClaim.vue?vue&type=template&id=73b6812b&lang=pug&"
import script from "./ModalShipmentClaim.vue?vue&type=script&lang=js&"
export * from "./ModalShipmentClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports